import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { loginUser } from '../../redux/actions';
import toast from 'react-hot-toast';
import AOS from "aos";
import "aos/dist/aos.css";

const Login = ({ loading, error, loginUserAction }) => {

  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    AOS.init();
    let message
    if (error !=='') {
      switch(error) {
      case 'invalid' : message = "ID or Pasword is Invalid"; break;
      default : message = "Login Error"; break;
      }
      toast.error(message);
    }

  }, [error]);

  const onUserLogin = (event) => {
    event.preventDefault();
    if (!loading) {
      if (email !== '' && password !== '') {
        let values = {email : email, password : password}
        loginUserAction(values, navigate);
      }
    }
  };

  const linkTo = (link) => {
    navigate('/' + link);
  }
  
  return  (
    <div className="container">
      <div className="toptitle" >
        <span onClick={() =>linkTo('welcome')}>
          <i className="fa-solid fa-arrow-left"></i>
        </span>
        <span>SignIn</span>
      </div>
      <div id="login_welcome" className="welcome" data-aos="fade-right">
        Welcome
      </div>


      <div className="containerForm" data-aos="fade-down" data-aos-duration="1400" data-aos-anchor-placement="center-bottom" >
        <label  className="usertitle">아이디(이메일)</label>
        <input 
          className="userinput"
          placeholder="이메일"
          value={email} 
          onChange={e => setEmail(e.target.value)}
        />

        <label  className="usertitle">비밀번호</label>
        <input
          className="userinput"
          placeholder="비밀번호"
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
        />
        <div className="submitButton">
          <button onClick={onUserLogin} className="button">
            로그인
          </button>
        </div>

        <NavLink  to='/forgotpassword'>
          <div className="linkforgot">
          Forgot Password?
          </div>
        </NavLink>
      </div>
    </div>
  );
};

const mapStateToProps = ({ authUser }) => {
  const { loading, error } = authUser;
  return { loading, error };
};

export default connect(mapStateToProps, {
  loginUserAction: loginUser,
})(Login);


